import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SearchComponent } from '@app/components';
import { DocumentTag } from '@app/models/documents/document-tag.model';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    imports: [PlatformModule, CommonModule, TranslateModule, RouterModule],
    selector: 'app-document-tag-menu',
    templateUrl: './document-tag-menu.template.html',
    styleUrls: ['./document-tag-menu.style.scss'],
})
export class DocumentTagMenuComponent implements OnChanges {
    @ViewChild('searchBar') searchBar!: SearchComponent;

    @Input() documentTags: DocumentTag[] = [];
    @Output() documentTagsChange = new EventEmitter<DocumentTag[]>();

    @Input() selectedTags = new Set<DocumentTag>();
    @Output() select = new EventEmitter<Set<DocumentTag>>();

    protected pathRoot: string = 'documents-v2';

    onToggle(documentTag: DocumentTag): void {
        this.selectedTags.has(documentTag) ? this.selectedTags.delete(documentTag) : this.selectedTags.add(documentTag);
        this.select.emit(this.selectedTags);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { documentTags } = changes;
        if (documentTags) {
            this.clearTags();
        }
    }

    clearTags(): void {
        this.selectedTags.clear();
        this.select.emit(this.selectedTags);
    }

    async onSearch(searchQuery: string | null | undefined): Promise<void> {
        this.selectedTags.clear();

        const query = DocumentTag.query();
        if (searchQuery) {
            query.where('query', searchQuery);
        }

        const [updatedTags] = await query.all();
        this.documentTagsChange.emit(updatedTags);
    }
}
